/* tslint:disable:typedef-whitespace */
/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {ICommand}            from '@/util/i.command';
import {TSOEditor}           from './t.s.o.editor';

/**
 *
 * @class SetFRTSpeedCommand
 *
 * @brief reversible updates of the tso freight speed
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class SetFRTSpeedCommand implements ICommand {

  private oldValue: number;
  private newValue: number;
  private editor:   TSOEditor;

  constructor(oldValue: number, newValue: number, editor: TSOEditor) {

    this.oldValue = oldValue;
    this.newValue = newValue;
    this.editor   = editor;
  }

  /** effect the command */
  execute() {

    this.editor.setFRTSpeed(this.newValue);
  }

  /** reverse the command's effects */
  unExecute() {

    this.editor.setFRTSpeed(this.oldValue);
  }

  /** return a string summary of this command */
  asString(): string {

    return '[frt speed] ' + this.oldValue + ' => ' + this.newValue;
  }

}
